<div class="blog__details__quote" *ngIf="user?.enabled === false">
    <div>
        <p>
            {{ 'login.verify' | translate }}
            <a class="link-hover btn text-white bg-secondary" (click)="verifyAccountAttempt()">{{ 'login.click' | translate }}</a>
        </p>
    </div>
</div>